import './CRUDTable.css'

function CRUDTable({children,hallSeats}) {
  return (
    <div className={`${hallSeats ? "hallseat_data_table_wrapper" : "data_table_wrapper"}`}>
        <table 
            id="dashboardTable" 
            className="table dataTable table-borderless align-middle text-center dashboard_table"
        >
            {children}
        </table>
    </div>  )
}

export default CRUDTable